import { Message , Loading } from 'element-ui';
import store from '@/store/index.js';
export default {
  /**
   * 时间戳转换
   * @param  {[Unixtimestamp]}  [时间戳/秒]
   * @example
   * @common.getLocalTime('1234124234');
   */
  getLocalTime: (Unixtimestamp) => {
    let len = (Unixtimestamp + '').length;
    let commonTime = new Date(len == 10 ? Unixtimestamp * 1000 : Unixtimestamp),
      year = commonTime.getFullYear(),
      month = commonTime.getMonth() + 1,
      day = commonTime.getDate(),
      hours = commonTime.getHours(),
      minutes = commonTime.getMinutes(),
      seconds = commonTime.getSeconds();

    function format(t) {
      return t >= 10 ? t : ("0" + t);
    }
    return {
      year: year,
      month: format(month),
      day: format(day),
      hours: format(hours),
      minutes: format(minutes),
      h_m: format(hours) + ":" + format(minutes),
      date: year + " " + format(month) + "." + format(day),
      date1: year + "-" + format(month) + "-" + format(day),
      date_cn: year + "年" + format(month) + "月" + format(day) + "日",
      full: year + "." + format(month) + "." + format(day) + " " + format(hours) + ":" + format(minutes),
      wmtime: year + "-" + format(month) + "-" + format(day) + " " + format(hours) + ":" + format(minutes)
    }
  },
  /**
   * @param {Object} len 随机多少位
   * 获取随机码
   */
  getRandomString: len => {
    len = len || 32;
    var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = chars.length;
    var pwd = '';
    for (var i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  },
  // 切换正式测试地址
  switchPlaceUrl(){
    let url;
    if(process.env.NODE_ENV=='production'){
      url = 'https://m.texperts.com'
    }else{
      url = 'http://m.tmtexperts.net'
    }
    window.open(url, '_blank');
  },
}



// WEBPACK FOOTER //
// ./src/common/js/common.js